import { useEffect, useRef, useState } from "react";
import { prefersReducedMotion } from "./reducedMotion";

// Calm crossfade between existing site lines; pauses on hover and in hidden tabs.
export const RotatingLine = ({ lines, interval = 3500, className = "" }) => {
  const [i, setI] = useState(0);
  const paused = useRef(false);
  useEffect(() => {
    if (prefersReducedMotion() || lines.length < 2) return undefined;
    const id = setInterval(() => {
      if (!paused.current && !document.hidden) setI((x) => (x + 1) % lines.length);
    }, interval);
    return () => clearInterval(id);
  }, [lines.length, interval]);
  return (
    <p
      data-testid="hero-rotating-line"
      className={`grid ${className}`}
      onMouseEnter={() => { paused.current = true; }}
      onMouseLeave={() => { paused.current = false; }}
    >
      {lines.map((l, k) => (
        <span
          key={l}
          aria-hidden={k !== i}
          data-active={k === i}
          className="rot-line [grid-area:1/1]"
          style={{ opacity: k === i ? 1 : 0, transform: k === i ? "none" : "translateY(6px)" }}
        >
          {l}
        </span>
      ))}
    </p>
  );
};
